import { RegionScope } from "~/hooks/useScope";
import { PlatformBreadcrumbs } from "~/pages/platform/components";
import { PolicyDetailPage } from "~/pages/shared/policy/PolicyDetailPage";

export interface PlatformPolicyDetailPageProps {
  scope: RegionScope;
}

export function PlatformPolicyDetailPage({
  scope,
}: PlatformPolicyDetailPageProps) {
  return (
    <PolicyDetailPage
      scope={scope}
      basePath="/policies"
      defaultTitle="Platform Policy Detail"
      renderBreadcrumbs={(title) => <PlatformBreadcrumbs currentPage={title} />}
    />
  );
}
